import axios from 'axios';

const TIMEOUT_TIME = 10_000;

// 공공 api 전용 axios instance (v2 API는 JSON 반환)
export const publicApiInstance = axios.create({});

const cancelTokenSource = () => {
  const cancelToken = axios.CancelToken.source();
  return {
    token: cancelToken.token,
    cancel: cancelToken.cancel,
  };
};

let firstRequestCancelToken = null;

publicApiInstance.interceptors.request.use(
  async (config) => {
    firstRequestCancelToken = cancelTokenSource();
    config.cancelToken = firstRequestCancelToken.token;
    config.timeout = TIMEOUT_TIME;
    return config;
  },
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || 'Something went wrong'
    )
);

publicApiInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (axios.isCancel(error)) {
      Promise.resolve();
    }
    return Promise.reject(
      (error.response && error.response.data) || 'Something went wrong'
    );
  }
);
